var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7264 9.16232C5.72651 9.44092 5.50063 9.66683 5.22213 9.66672C5.08759 9.66672 4.96 9.61362 4.86544 9.51906C4.77088 9.4245 4.71777 9.29691 4.71778 9.16241L4.71785 5.7266L1.28199 5.72658C1.14749 5.72659 1.0199 5.67348 0.925344 5.57892C0.830842 5.48442 0.7777 5.35688 0.777588 5.22237C0.777475 4.94382 1.00338 4.71793 1.28186 4.71804L4.71778 4.71806L4.71776 1.28224C4.71765 1.00363 4.94353 0.777719 5.22203 0.777832C5.5007 0.777826 5.72639 1.00349 5.72638 1.28214L5.7264 4.71804L9.16217 4.71797C9.44081 4.71796 9.66648 4.94364 9.66648 5.2222C9.66659 5.5008 9.4407 5.72672 9.16221 5.7266L5.72638 5.72668L5.7264 9.16232Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.05eb9f19.svg";
export { ForwardRef as ReactComponent };